module.exports = __webpack_public_path__ + "static/media/wordpress-simple.7c7c450a.svg";